import { Authentication } from '@amzn/awscat-portal-authentication-library';

import { GetEnvironmentConfig } from '../Environments';

export const getAuthToken = (): Promise<string> => {
    const getToken = async () => {
        try {
            const token = await authentication.getToken(true);
            return token;
        } catch (err) {
            console.log(err);
            throw err;
        }
    };
    return getToken();
};

const environmentConfig = GetEnvironmentConfig();
const authentication = new Authentication(environmentConfig.authEndpoint.url, environmentConfig.portalClient, undefined);

export default authentication;
